// extracted by mini-css-extract-plugin
export default {"transactions-metrics-box":"transactions-metrics-box_transactions-metrics-box__wY230"};